import { NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {
  MatLegacyTableDataSource as MatTableDataSource,
  MatLegacyTableModule as MatTableModule,
} from '@angular/material/legacy-table';
import { BazisMaterialHelper, CadModelMaterialType, CuttingCadModelMaterialLink } from 'cloud-shared-lib';
import * as _ from 'lodash';

@Component({
  selector: 'cutting-product-materials-link-info',
  templateUrl: './product-materials-link-info.component.html',
  styleUrls: ['./product-materials-link-info.component.scss'],
  standalone: true,
  imports: [NgIf, MatDividerModule, MatTableModule],
  encapsulation: ViewEncapsulation.None,
})
export class ProductMaterialsLinkInfoComponent {
  materialDisplayedColumns = ['name', 'thickness', 'link_name', 'size'];
  buttDisplayedColumns = ['name', 'thickness', 'link_name'];
  slotDisplayedColumns = ['name', 'link_name'];

  dataSourceMaterials: MatTableDataSource<CuttingCadModelMaterialLink> = new MatTableDataSource();
  dataSourceButts: MatTableDataSource<CuttingCadModelMaterialLink> = new MatTableDataSource();
  dataSourceSlots: MatTableDataSource<CuttingCadModelMaterialLink> = new MatTableDataSource();

  @Input() set productMaterialLink(val: CuttingCadModelMaterialLink[]) {
    this.fillDataSources(val);
  }

  constructor(public dialogRef: MatDialogRef<ProductMaterialsLinkInfoComponent>) {}

  formatOriginMaterial(material: CuttingCadModelMaterialLink): string {
    return BazisMaterialHelper.formatMaterialName(material.originalMaterialFullName, $localize`Артикул`);
  }

  private fillDataSources(productMaterialLink: CuttingCadModelMaterialLink[]): void {
    productMaterialLink.forEach(linkMaterial => {
      switch (linkMaterial.materialType) {
        case CadModelMaterialType.Side:
          this.dataSourceButts.data.push(linkMaterial);
          break;

        case CadModelMaterialType.Plate:
        case CadModelMaterialType.Linear:
          if (!_.isEmpty(linkMaterial.linkedMaterialName)) {
            this.dataSourceMaterials.data.push(linkMaterial);
          }
          break;

        case CadModelMaterialType.Slot:
          this.dataSourceSlots.data.push(linkMaterial);
          break;
      }
    });
  }
}
